<template>
  <div>
    <div class="app-main-inner-row row-grid" style="flex-grow: 1; background: #F0F3F8">
      <div style="width: 400px; height: 80px; background: white">
        <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px;">
          <el-button type="primary" @click="showBranchSelectDialog">{{ $t('SystemMaintenance.SetExclusionOffices') }}</el-button>
          <el-input v-model="branchSelectDialog.showExclusionOfficeIds" :disabled="true" />
        </div>
      </div>
    </div>
    <branch-select-dialog
      :visible.sync="branchSelectDialog.visible"
      :office-list="branchSelectDialog.officeList"
      :value="branchSelectDialog.value"
      @callback="branchSelectDialog.callback"
    />
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getExclusionOffice, saveExclusionOffice } from '@/api/sysManage/baseConfig/ExclusionOffice'

export default {
  name: 'ExclusionOffice',
  components: {
    BranchSelectDialog
  },
  data() {
    return {
      form: {
        uuid: '',
        exclusionOfficeIds: ''
      },
      initialOfficeIds: '',
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {},
        officeList: [],
        showExclusionOfficeIds: '' // 显示用豁免分公司
      }
    }
  },
  watch: {
    'form.exclusionOfficeIds'(newVal) {
      const values = newVal.split(',')
      this.branchSelectDialog.showExclusionOfficeIds = Array.from(values,
        p => ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(p), 'code')
      ).join(',')
    }
  },
  async created() {
    await cache.load(cacheName.OFFICE_LIST)
    this.branchSelectDialog.officeList = cache.officeList
  },
  methods: {
    onShow() {
      this.toQuery()
    },
    toQuery() {
      const loading = getLoading()
      getExclusionOffice().then(res => {
        this.form = res.data
        this.initialOfficeIds = this.form.exclusionOfficeIds
      }).finally(() => loading.close())
    },
    save() {
      this.loading = getLoading()
      saveExclusionOffice(this.form).then(() => {
        this.toQuery()
        this.branchSelectDialog.visible = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
      }).catch(() => {
        this.form.exclusionOfficeIds = this.initialOfficeIds
      }).finally(() => {
        this.loading.close()
      })
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.toNumArray(this.form.exclusionOfficeIds)
      this.branchSelectDialog.callback = val => {
        this.form.exclusionOfficeIds = this.toTxt(val)
        this.save()
      }
      this.branchSelectDialog.visible = true
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    }

  }
}
</script>
